import React from "react";
import { get, isEmpty } from "lodash-es";
import CustomTree from "../CustomTree/CustomTree";
import PerfectScrollbar from "react-perfect-scrollbar";
import DataComponent from "../DataComponent";
import Loading from "../Loading";
import NoData from "../NoData/NoData";
import IconButton from "../Button/IconButton";
import { classnames } from "../../utils/text";
import Button from "../Button";
import DeleteIcon from "../../assets/images/icon/delete-icon-01.svg";
import emptyUserImage from "../../assets/images/empty-user-img.png";
import { employeePreview } from "../../utils/employee";
import { preventEvent } from "../../utils/element";

import { includes, forEach } from "lodash";

const PersonTreeTable = ({
  isLoading,
  mode = "detail",
  treeData,
  setTreeData,
  tableData,
  onSelect,
  defaultSelectedKeys,
  buttons,
  tableFields,
  handleAddEmployee,
  handleDeleteEmployee,
  selectedData,
  isTax = false
}) => {

  const employeesSort = [];
  const leaveEmployees = [];
  // forEach(sortBy(tableData.employees, 'code'), item => {
  forEach(tableData.employees, item => {
    if (!includes(item.name, "(퇴사)")) {
      employeesSort.push(item);
    } else {
      leaveEmployees.push(item);
    }
  });
  forEach(leaveEmployees, item => {
    employeesSort.push(item);
  });

  const personFields = [
    {
      key: "user",
      width: "40%",
      onValue: (value, field, data) => {
        const { profileImg, gradeName, code, name } = data;
        return (
          <div className="user-wrap" style={{
            whiteSpace: 'nowrap'
          }}>
            <div className="profile-container" onClick={(e) => showPreviewEmployee(e, data)}>
              <div className="profile-img-wrap">
                <img src={profileImg || emptyUserImage} alt={data.name} />
              </div>
              <span className="name">{name}</span>
            </div>
            <span className="grade">({code})</span>
            <span className="grade">{gradeName}</span>
          </div>
        );
      },
    },
    {
      key: "partName",
      width: "22%",
      className: "part-name",
    },
    {
      key: "email",
      width: "38%",
      className: "email",
    },
  ];

  const showPreviewEmployee = (e, _data) => {
    preventEvent(e);
    employeePreview(_data.idx, { isTax });
  };

  return (
    <>
      <div className="person-tree-table-container">
        {isLoading ? (
          <Loading />
        ) : (
          <>
            <div className="tree-view-container">
              <div className={classnames("tree-view-wrap", mode)}>
                <PerfectScrollbar>
                  {!isEmpty(treeData) && (
                    <CustomTree
                      treeData={treeData}
                      setTreeData={setTreeData}
                      handleSelect={onSelect}
                      defaultSelectedKeys={defaultSelectedKeys}
                    />
                  )}
                </PerfectScrollbar>
              </div>
              {mode === "modify" && (
                <div className="tree-control-button-container">
                  <div className={"tree-control-button-wrap"}>
                    {!isEmpty(buttons) &&
                      buttons.map(({ icon, action }, idx) => (
                        <IconButton key={idx} icon={icon} action={action} />
                      ))}
                  </div>
                </div>
              )}
            </div>
            <div className="tree-table-wrap">
              <PerfectScrollbar>
                <div className="table-title">
                  {!isEmpty(tableData.name) && (
                    <>
                      <span className="company-name">
                        {get(tableData, "name")}
                      </span>
                      {mode === "modify" &&
                        get(selectedData, "key") !== "company" &&
                        get(selectedData, "key") !== "unspecified" && (
                          <Button
                            className="float-right"
                            color="line"
                            label="사람추가"
                            onClick={handleAddEmployee}
                          />
                        )}
                    </>
                  )}
                  {!isEmpty(tableData.employees) && (
                    <span className="member-count">
                      총{" "}
                      <span className="color-main-100">
                        {get(tableData, "employees.length")}
                      </span>
                      명
                      <span>{` (재직 ${tableData?.employees?.filter(f => {
                        return f.office === 1;
                      }).length || 0}명 / 퇴직 ${tableData?.employees?.filter(f => {
                        return f.office === 0;
                      }).length || 0}명)`}</span>
                    </span>
                  )}
                </div>
                <div className="table-wrap">
                  {isEmpty(tableData.employees) ? (
                    <NoData />
                  ) : (
                    <table>
                      <colgroup>
                        <col></col>
                        {(tableFields || personFields).map(
                          (field, idx) => (
                            <col key={idx} width={field.width}></col>
                          )
                        )}
                      </colgroup>
                      <tbody>
                        {employeesSort.map((data, idx) => (
                          <tr key={idx}>
                            {mode === "modify" &&
                              get(selectedData, "key") !== "company" &&
                              get(selectedData, "key") !== "unspecified" && (
                                <td className="padding-right-16">
                                  <IconButton
                                    icon={DeleteIcon}
                                    onClick={() => handleDeleteEmployee(data)}
                                  />
                                </td>
                              )}
                            {mode === 'detail' && (
                              <td></td>
                            )}
                            {!isEmpty(tableFields)
                              ? tableFields.map((field, idx) => (
                                <td
                                  className={field.className || ""}
                                  key={idx}
                                >
                                  <DataComponent field={field} data={data} />
                                </td>
                              ))
                              : personFields.map((field, idx) => (
                                <td
                                  className={field.className || ""}
                                  key={idx}
                                >
                                  <DataComponent field={field} data={data} />
                                </td>
                              ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </PerfectScrollbar>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PersonTreeTable;
